import(/* webpackMode: "eager" */ "/app/app/[locale]/not-found.tsx");
